import gql from "graphql-tag";
import ProjectWasteMappingFragment from "../fragments/ProjectWasteMappingFragment";

// UpsertProjectWasteMapping + the project's trail row in ONE document. Hasura runs
// all root mutation fields of a single document in one transaction, so the change and its version
// can never exist without each other. The trail row is a display-only log line (see
// wasteVersionSnapshot.ts) — a revision's waste STATE is these rows themselves, scoped by
// revision_id, which the insert trigger stamps. created_by / tenant_id / source are stamped via
// presets; revision_id is not insertable at all.
const UpsertProjectWasteMappingWithVersionMutation = gql`
  mutation UpsertProjectWasteMappingWithVersion(
    $objects: [projectWasteMapping_insert_input!]!
    $version: projectVersion_insert_input!
  ) {
    insert_projectWasteMapping(
      objects: $objects
      on_conflict: {
        constraint: project_material_waste_mapping_pkey
        update_columns: [
          label
          materialId
          materialWasteTypeId
          pickupDate
          projectId
          customWeight
          projectWasteTypeCustomId
          materialWeightSnapshot
        ]
      }
    ) {
      affected_rows
      returning {
        ...projectWasteMapping
      }
    }
    insert_projectVersion_one(object: $version) {
      id
    }
  }
  ${ProjectWasteMappingFragment}
`;

export default UpsertProjectWasteMappingWithVersionMutation;
